// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import 'rc-time-picker/assets/index.css';
import { InputGroup } from 'react-bootstrap';

export default class MyTimePicker extends React.PureComponent {
  onChange = val => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { onChange } = this.props;
    if (!val) {
      onChange(-1);
      return;
    }
    const seconds = val.hour() * 3600 + val.minute() * 60;
    onChange(seconds);
  };

  render() {
    const {
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      disabled,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      value,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      notClear,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      tbd,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      placeholder,
      // TODO: Fix this the next time the file is edited.
      // @ts-ignore
      // eslint-disable-next-line react/prop-types
      minuteStep,
    } = this.props;
    const iconClass = notClear ? 'none' : 'fas fa-times';
    const startValue = moment().hour(0).minute(0);
    let val;
    if (value === -1 || tbd) {
      val = undefined;
    } else {
      val = moment()
        .hour(Math.floor(value / 3600))
        .minute((value % 3600) / 60);
    }
    return (
      <InputGroup>
        <TimePicker
          onChange={this.onChange}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          step={10}
          placeholder={placeholder}
          defaultOpenValue={startValue}
          use12Hours
          minuteStep={minuteStep || 1}
          clearIcon={<i className={`my-clear-time-icon ${iconClass}`} />}
          showSecond={false}
          disabled={disabled}
          value={val}
          inputReadOnly
        />
        <InputGroup.Addon>
          <i className='fas fa-clock' />
        </InputGroup.Addon>
      </InputGroup>
    );
  }
}
